import { createReducer } from '@reduxjs/toolkit';
import { CreateMessage } from '@store/broadcast-messages/features/create-message/create-message';
import { CreateMessageFailure } from '@store/broadcast-messages/features/create-message/create-message-failure';
import { CreateMessageSuccess } from '@store/broadcast-messages/features/create-message/create-message-success';
import { GetMessages } from '@store/broadcast-messages/features/get-message/get-messages';
import { GetMessagesFailure } from '@store/broadcast-messages/features/get-message/get-messages-failure';
import { GetMessagesSuccess } from '@store/broadcast-messages/features/get-message/get-messages-success';
import { GetUsersCount } from '@store/broadcast-messages/features/get-users-count/get-users-count';
import { GetUsersCountFailure } from '@store/broadcast-messages/features/get-users-count/get-users-count-failure';
import { GetUsersCountReset } from '@store/broadcast-messages/features/get-users-count/get-users-count-reset';
import { GetUsersCountSuccess } from '@store/broadcast-messages/features/get-users-count/get-users-count-success';
import { UpdateMessage } from '@store/broadcast-messages/features/update-message/update-message';
import { UpdateMessageFailure } from '@store/broadcast-messages/features/update-message/update-message-failure';
import { UpdateMessageSuccess } from '@store/broadcast-messages/features/update-message/update-message-success';

import { IBroadcastMessagesState } from './types';

export const broadcastMessageState: IBroadcastMessagesState = {
  broadcastMessages: [],
  usersCount: null,
  requests: {
    getBroadcastMessagesPending: false,
    createBroadcastMessagePending: false,
    updateBroadcastMessagePending: false,
    getUserCountPending: false,
  },
};

const reducer = createReducer(broadcastMessageState, (builder) =>
  builder
    .addCase(GetMessages.action, GetMessages.reducer)
    .addCase(GetMessagesSuccess.action, GetMessagesSuccess.reducer)
    .addCase(GetMessagesFailure.action, GetMessagesFailure.reducer)
    .addCase(CreateMessage.action, CreateMessage.reducer)
    .addCase(CreateMessageSuccess.action, CreateMessageSuccess.reducer)
    .addCase(CreateMessageFailure.action, CreateMessageFailure.reducer)
    .addCase(UpdateMessage.action, UpdateMessage.reducer)
    .addCase(UpdateMessageSuccess.action, UpdateMessageSuccess.reducer)
    .addCase(UpdateMessageFailure.action, UpdateMessageFailure.reducer)
    .addCase(GetUsersCount.action, GetUsersCount.reducer)
    .addCase(GetUsersCountSuccess.action, GetUsersCountSuccess.reducer)
    .addCase(GetUsersCountFailure.action, GetUsersCountFailure.reducer)
    .addCase(GetUsersCountReset.action, GetUsersCountReset.reducer),
);

export default reducer;
